import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import 'bootstrap-sass/assets/javascripts/bootstrap.js';
import 'react-fastclick';
import moment from 'moment';
import Promise from 'bluebird';

// Styles
import 'app.scss';

// Components
import Auth from 'modules/auth/auth';
import PageLayout from 'modules/page-layout/page-layout';

// Services
import EmailAddress from 'services/data/email-address';
import Person from 'services/data/person';
import Company from 'services/data/company';
import Settings from 'services/data/settings';
import Team from 'services/data/team';
import { addHttpInterceptor } from 'services/http-config';

// Actions
import * as authActions from 'modules/auth/actions';
import 'modules/history/actions';
import { clearAlerts } from 'modules/alerts/actions';

// Polyfill
import 'es6-promise/auto';

// Promise config disable forgotten return warnings
Promise.config({
  warnings: {
    wForgottenReturn: false
  },
  cancellation: true
});

// Moment config
// en-short inherits from the default English locale, but has short names for relative time
moment.defineLocale('en-short', {
  parentLocale: 'en',
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%ds',
    m: '%dm',
    mm: '%dm',
    h: '%dh',
    hh: '%dh',
    d: '%dd',
    dd: '%dd',
    M: '%dmo',
    MM: '%dmo',
    y: '%dy',
    yy: '%dy'
  }
});
// When you define a locale, moment automatically switches to it, but we want 'en' to be the default
// and we will switch to en-short only when we need it, so we explicitly switch back to 'en'
moment.locale('en');

// Set up our service worker, which as of now just indicates that we are a web app
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    navigator.serviceWorker.register('/sw.js').then(_.noop);
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  }
}


// Component
class App extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    auth: PropTypes.object
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.auth.token !== nextProps.auth.token && nextProps.auth.token) {
      addHttpInterceptor({ Authorization: `Bearer ${nextProps.auth.token}` });
      Company.initializeSocket();
      Person.initializeSocket();
      Team.initializeSocket();
      Settings.initializeSocket();
    }

    if (this.props.auth.profile.email !== nextProps.auth.profile.email) {
      this.refreshUser(nextProps.auth.profile.email);
    }
  }

  refreshUser(email) {
    if (!email) return;

    EmailAddress.find({ where: { email: { ilike: email } }, load: ['contact.team'] })
      .then((foundEmails) => {
        const currentUser = new Person(foundEmails[0].contact);
        authActions.updateCurrentUser(currentUser);
        clearAlerts();
      });
  }

  render() {
    const { children } = this.props;

    return (
      <Auth
        clientId="6Hx7eJ3FajNHjuMNYK2q7rxsIajYP3we"
        domain="praece.auth0.com"
      >
        <PageLayout>{children}</PageLayout>
      </Auth>
    );
  }
}


function mapStateToProps(state) {
  return {
    auth: state.auth,
    path: state.location.pathname
  };
}


// Exports
export default connect(mapStateToProps)(App);
